import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import classNames from 'classnames/bind';
import { Card, ChevronRightIcon, Link, Text } from '@beef/ui-kit';
import commonStyle from "../styles.module.pcss";
import style from "./styles.module.pcss";
var cx = classNames.bind(_objectSpread(_objectSpread({}, commonStyle), style));
export var FeaturesList = function FeaturesList(_ref) {
  var featuresList = _ref.featuresList;
  return /*#__PURE__*/React.createElement("ul", {
    className: cx('feature-list'),
    "data-t-id": "FaqMain-FeaturesList"
  }, featuresList === null || featuresList === void 0 ? void 0 : featuresList.map(function (item, i) {
    var _item$link;
    return /*#__PURE__*/React.createElement("li", {
      className: cx('feature-list-item'),
      key: i
    }, item.icon && /*#__PURE__*/React.createElement(Card, {
      bordered: !item.iconFullWith,
      className: cx({
        'icon-wrapper': true,
        'full-width': item.iconFullWith
      })
    }, /*#__PURE__*/React.createElement("img", {
      alt: "icon",
      className: cx('icon'),
      src: item.icon,
      "data-t-id": "FaqMain-FeaturesList"
    })), /*#__PURE__*/React.createElement("div", null, item.text && /*#__PURE__*/React.createElement(Text, {
      size: "size5-r-s"
    }, item.text), item.description && /*#__PURE__*/React.createElement("div", {
      className: cx('description')
    }, /*#__PURE__*/React.createElement(Text, {
      color: "grey50",
      size: "size6-r"
    }, item.description)), ((_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.url) && /*#__PURE__*/React.createElement("div", {
      className: cx('link')
    }, /*#__PURE__*/React.createElement(Link, {
      href: item.link.url,
      isNoUnderline: true,
      rightIcon: /*#__PURE__*/React.createElement(ChevronRightIcon, {
        size: "xs"
      }),
      size: "size6-m"
    }, item.link.text || 'Перейти'))));
  }));
};